import { render, staticRenderFns } from "./VxTooltip.vue?vue&type=template&id=3a40b4b1&scoped=true"
import script from "./VxTooltip.vue?vue&type=script&lang=js"
export * from "./VxTooltip.vue?vue&type=script&lang=js"
import style0 from "./VxTooltip.vue?vue&type=style&index=0&id=3a40b4b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40b4b1",
  null
  
)

export default component.exports